import { createFileRoute } from '@tanstack/react-router';

import { SyncRelationQueuePage } from '@pages/sync';

/**
 * Sync - Relation Queue
 *
 * Route: /:locale/sync/relation-queue
 */
export const Route = createFileRoute('/$locale/_authenticated/sync/relation-queue')({
  component: SyncRelationQueueRoute,
});

function SyncRelationQueueRoute() {
  return <SyncRelationQueuePage />;
}
